import * as React from 'react';
import { CategoryFetcher } from '../category';
import { SolutionPageContainer } from '../solution-page';
import { CollectionFetcher } from '../collection';
import { SearchResultFetcher } from '../search-result';
import { Home } from '../home';
import { Origin, Path } from '../../enums/marketplace-enums';
import s from './marketplace-router.scss';
import { config } from '../../config';
import { ShareAppContainer } from '../share-app';
import { FinishSetupContainer } from '../finish-setup';
import { ManageApps } from '../manage-apps/manage-apps';
import { ErrorBoundry } from '../error-boundry';
import { MarketplaceRouterSeo } from './marketplace-router-seo';
import { DeveloperPageContainer } from '../developer-page-container';
import { OpenAppWithParams } from '../open-app-with-params';
import { composer } from '../../component-decorators/composer';
var showComponent = function (route, marketplaceStore, showHolidaySale) {
    marketplaceStore.resetClearSearchBeforeDate();
    switch (route.path) {
        case Path.CATEGORY:
            marketplaceStore.resetClearSearchBeforeDate();
            return (React.createElement(CategoryFetcher, { slug: route.slug, subCategories: route.subCategories }));
        case Path.COLLECTION:
            return React.createElement(CollectionFetcher, { slug: route.slug });
        case Path.SEARCH:
            return (React.createElement(SearchResultFetcher, { query: route.query && route.query.trim(), showHolidaySale: showHolidaySale }));
        case Path.WEB_SOLUTION:
            marketplaceStore.resetClearSearchBeforeDate();
            return (React.createElement(SolutionPageContainer, { slug: route.slug, mode: route.appPageMode, previewLangCode: route.languageCode, version: route.version }));
        case Path.SHARE:
            return (React.createElement(ShareAppContainer, { appDefId: route.shareAppData.appDefId, shareId: route.shareAppData.shareId }));
        case Path.FINISH_SETUP:
            return (React.createElement(FinishSetupContainer, { slug: route.slug, appVersion: route.version }));
        case Path.DEVELOPER:
            return React.createElement(DeveloperPageContainer, { slug: route.slug });
        case Path.MANAGE_APPS:
            return (React.createElement(ManageApps, { manageAppsDeepLinkData: route.manageAppsDeepLinkData }));
        case Path.OPEN_APP_WITH_PARAMS:
            return (React.createElement(OpenAppWithParams, { appId: route.slug, options: route.openAppOptions }));
        default:
            return React.createElement(Home, null);
    }
};
export var MarketplaceRouter = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, showHolidaySale = _a.showHolidaySale;
    var marketPlaceRouterStyles = config.origin === Origin.STANDALONE
        ? s.marketplaceRouterSa
        : config.origin === Origin.EDITOR
            ? s.marketplaceRouterEditor
            : s.marketplaceRouter;
    console.log("marketplace-component/src/components/marketplace-router/marketplace-router.tsx file - line 29 - " + Date.now());
    return (React.createElement("div", { "data-testid": "marketplace-router", className: marketPlaceRouterStyles },
        React.createElement(ErrorBoundry, null,
            config.origin === Origin.STANDALONE && React.createElement(MarketplaceRouterSeo, null),
            showComponent(marketplaceStore.route, marketplaceStore, showHolidaySale))));
});
//# sourceMappingURL=marketplace-router.js.map